import comparaisonQualiteApi from '@/api/comparaison-produits.api'

const getDefaultState = () => {
  return {
    listeGraphesConstruisibles: []
  }
}
const module = {
  namespaced: true,
  state: getDefaultState(),

  getters: {
    listeGraphesConstruisibles (state) {
      return state.listeGraphesConstruisibles
    }
  },
  mutations: {
    UPDATE_GRAPHE_CONSTRUISIBLE (state, listeGraphesConstruisibles) {
      state.listeGraphesConstruisibles = listeGraphesConstruisibles
    }
  },
  actions: {
    getGrapheConstruisible ({ commit }, codeGraineRs3) {
      return comparaisonQualiteApi.getGraphesComparaisonConstruisibles(codeGraineRs3)
        .then(response => {
          commit('UPDATE_GRAPHE_CONSTRUISIBLE', response)
        })
    },
    getComparaisonQualitePS ({ rootGetters }, { anneeCourante, codeGraineRs3, filtres }) {
      let username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      return comparaisonQualiteApi.getComparaisonQualitePS(username, anneeCourante, codeGraineRs3, filtres)
        .then(response => {
          return response
        })
    },
    getComparaisonQualiteProteine ({ rootGetters }, { anneeCourante, codeGraineRs3, filtres }) {
      let username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      return comparaisonQualiteApi.getComparaisonQualiteProteine(username, anneeCourante, codeGraineRs3, filtres)
        .then(response => {
          return response
        })
    },
    getComparaisonQualiteHumidite ({ rootGetters }, { anneeCourante, codeGraineRs3, filtres }) {
      let username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      return comparaisonQualiteApi.getComparaisonQualiteHumidite(username, anneeCourante, codeGraineRs3, filtres)
        .then(response => {
          return response
        })
    }
  }
}

export default module
